import React from "react";
import { Text } from "../../atoms/Text/Text";
import styles from "./GameEnd.css";

type SharerState = {
  isCopied: boolean;
};

type SharerProps = {
  text: string;
  isOpen: boolean;
  onClose: () => void;
};

export class Sharer extends React.Component<SharerProps, SharerState> {
  private dialogRef = React.createRef<HTMLDialogElement>();
  private dialogWrapperRef = React.createRef<HTMLDivElement>();
  state = {
    isCopied: false,
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event: MouseEvent) => {
    if (
      this.dialogWrapperRef.current &&
      !this.dialogRef.current.contains(event.target as Node)
    ) {
      this.props.onClose();
    }
  };

  async copyTextToClipboard(text: string) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  handleCopyClick = () => {
    this.copyTextToClipboard(this.props.text)
      .then(() => {
        this.setState({ isCopied: true });
        setTimeout(() => {
          this.setState({ isCopied: false });
        }, 1500);
      })
      .catch((err) => console.log(err));
  };

  render() {
    const { isCopied } = this.state;
    const { text, isOpen } = this.props;

    return (
      <div
        className={styles.gameEndShareWrapper}
        style={{ display: isOpen ? "flex" : "none" }}
        ref={this.dialogWrapperRef}
      >
        <dialog
          className={styles.gameEndSharePopUp}
          ref={this.dialogRef}
          aria-modal="true"
          role="dialog"
          open={isOpen}
          aria-hidden={!isOpen}
          aria-label="Share your score"
        >
          <Text as="div" size="xss" content={text} isDangerously />
          {isCopied ? (
            <Text
              size="xss"
              color="accent"
              ariaLabel="Copied to clipboard"
              ariaLive="polite"
              role="status"
            >
              Copied!
            </Text>
          ) : (
            <button
              className={styles.gameEndCopyButton}
              onClick={this.handleCopyClick}
            >
              <Text size="xss" color="aarpOutline">
                Copy to clipboard
              </Text>
            </button>
          )}
        </dialog>
      </div>
    );
  }
}
